import PropTypes from 'prop-types';
import React from 'react';
import { map } from 'lodash';
import { useNewCapability } from 'sharedHooks';
import { Row } from 'react-bootstrap';
import EnergyParameterSection from './Sections/EnergyParameterSection';
import './style.scss';

const EnergyRelatedSignalsListComponent = (props) => {
    const { model, actions } = props;
    const capability = useNewCapability();

    const sectionKpi = [{ data: model?.energyRelatedKPIsList }];

    return (
        <div className='signal-block' id='signal-block'>
            {model?.energyRelatedKPIsList?.length ?
                <Row className='trend-kpi-list measurement-list-container'>
                    {
                        map(sectionKpi, (kpiSection, kpiIndex) => {
                            return <EnergyParameterSection
                                key={kpiIndex}
                                section={kpiSection}
                                capability={capability}
                                dateSelection={model?.dateSelection}
                                selectedTrendsData={model?.selectedTrendsData}
                                selectedTrendKPIs={model?.selectedTrendKPIs}
                                selectedNotification={model?.selectedNotification}
                                setShowLimitSetting={actions?.setShowLimitSetting}
                                setClickedConfigKpi={actions?.setClickedConfigKpi} />;
                        })
                    }
                </Row> : null}
        </div>
    );
};

EnergyRelatedSignalsListComponent.propTypes = {
    actions: PropTypes.shape({
        setShowLimitSetting: PropTypes.func,
        setClickedConfigKpi: PropTypes.func,
    }),
    model: PropTypes.shape({
        energyRelatedKPIsList: PropTypes.array,
        selectedTrendKPIs: PropTypes.array,
        dateSelection: PropTypes.object,
        selectedTrendsData: PropTypes.array,
        selectedNotification: PropTypes.object,
        energyViewMode: PropTypes.string,
        isOnlyEnergySignalsSelected: PropTypes.bool,
        hasMixedSignalSelection: PropTypes.bool
    })
};

export default EnergyRelatedSignalsListComponent;
